<template>
    <div class="mainApp">
        <div class="cree"></div>
        <div class="content">
            <van-row type="flex" justify="center">
                <van-col span="6" class="avtor"></van-col>
            </van-row>
            <van-row type="flex" justify="center">
                <van-col span="6" class="phone">{{
                    userInfo.account
                }}</van-col>
            </van-row>
            <van-row type="flex" justify="center">
                <van-col span="14" class="evidenceType">给您分享证据</van-col>
            </van-row>
            <div class="fwCode">
                <van-row type="flex" justify="center" class="error">
                    <van-col span="20" v-if="isError">{{
                        errorText
                    }}</van-col>
                </van-row>
                <van-row type="flex" justify="center">
                    <van-col span="20">
                        <van-field
                            v-model="accessCode"
                            placeholder="请输入访问码"
                            class="myInput"
                            @focus="isError = false"
                            @blur="blurTo"
                        />
                    </van-col>
                </van-row>
            </div>
            <van-row type="flex" justify="center">
                <van-col span="14">
                    <div class="submit" @click="goNext">提交</div>
                </van-col>
            </van-row>
        </div>
        <Footer :pageId="1" />
        <van-dialog
            class="myDialog"
            v-model="visible"
            title=""
            confirmButtonColor="#008AFF"
            confirmButtonText="确定"
        >
            <div class="icon"><i class="el-icon-ali-jinggao"></i></div>
            <div class="diaCnt">
                分享证据已失效，请与证据持有者联系。
            </div>
        </van-dialog>
        <div id="captcha-element"></div>
    </div>
</template>

<script>
import { shareValidate ,shareLogin} from "@/api/service.js";
import Footer from "@/components/Mobile/footer.vue";
import NoTrace from '@/utils/noTrace.js';
export default {
    data() {
        return {
            accessCode: "",
            userInfo: {},
            isError: false,
            errorText: "提取证错误",
            randomKey: "",
            visible:false,
            nvc:'',
        };
    },

    components: {Footer},

    computed: {},

    created() {
        if(this.$route.query.randomKey){
            this.init();
        }else{
            this.$router.push({
                path: "/FileShow",
            });
        }
    },

    mounted() {
        NoTrace.init('captcha-element', 'captcha-button')
    },
    beforeDestroy() {
        NoTrace.reset()
    },

    methods: {
        blurTo(){
            document.body.scrollTop=0;
            document.documentElement.scrollTop=0;
        },
        async init() {
            let { randomKey } = this.$route.query;
            this.randomKey = randomKey;
            try {
                let res = await shareValidate({
                    randomKey,
                }); 
                sessionStorage.removeItem("codeMessage");
                sessionStorage.setItem('userinfo', JSON.stringify(res))
                if (res.accessStatus == 1) {
                    this.userInfo = res;
                    zhuge.track("证据分享_输入访问码", {
                        '端': "H5",
                    });
                } else {
                    this.$router.push({
                        path: "/FileShow",
                    });
                }
            } catch (error) {
                sessionStorage.removeItem("userinfo");
                sessionStorage.setItem('codeMessage', JSON.stringify({...error,randomKey}))
                if(error.code==20005){
                    console.log('证据分享失效');
                }else if([20018,20019,20020].includes(error.code)){
                    console.log('跳转弹框报统一错误')
                }else{
                    this.$toast(error.message);
                }
                this.$router.push({
                    path:'/FileShow',
                })
            }
            
            
        },
        async goNext() {
            if (this.accessCode !== "") {
                let that=this;
                // 开始获取无痕验证码
                NoTrace.start((nvc) => {
                    this.nvc = nvc
                }, this.executeFun, {
                    randomKey: that.$route.query.randomKey,
                    accessCode:that.accessCode,
                    nvc: '',
                    afsVersion: 2
                })
            } else {
                this.isError = true;
                this.errorText = "请输入访问码";
            }
        },
        executeFun(params){
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await shareLogin(params);
                    that.$router.push({
                        path: "/FileShow",
                    });
                    resolve(res)
                }catch (err) {
                    this.isError = true
                    this.errorText = err.message
                    reject(err)
                }
            })
        },
    },
};
</script>
<style lang="less" scoped>
.content {
    margin-top: 151px;
    text-align: center;
    padding-bottom: 120px;
    background:#fff;
    .avtor {
        background: url("../../assets/images/avtor.png") no-repeat;
        background-size: contain;
        width: 96px;
        height: 96px;
    }
    .phone {
        font-size: 30px;
        font-weight: bold;
        color: #333333;
        margin-top: 29px;
    }
    .evidenceType {
        font-size: 28px;
        font-weight: 400;
        color: #999999;
        margin-top: 29px;
        margin-bottom: 60px;
    }
    .fwCode{
        position: relative;
        margin-bottom:40px;
        .error {
            width: 100%;
            font-size: 24px;
            font-weight: 400;
            color: #f70f0f;
            text-align: center;
            position: absolute;
            top:-40px;
        }
    }
    .myInput {
        padding: 0;
        border-radius: 10px;
        /deep/ input {
            height: 84px;
            background: #f1f1f1;
            border-radius: 10px;
            font-size: 26px;
            font-weight: 400;
            color: #333333;
            text-align: center;
        }
    }
    .submit {
        background: #3988fe;
        border-radius: 10px;
        font-size: 26px;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        height: 84px;
        line-height: 84px;
        margin-top:40px;
    }
}
.cree {
    height: 20px;
    width: 100%;
    background: #f8f8f8;
}

.myDialog{
    .icon{
        text-align: center;
        i{
            color: #F87439;
            font-size: 80px;
        }
    }
    .diaCnt{
        text-align: center;
        padding: 20px 0;
    }
}

</style>
